var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodanddrinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9762 3.54545V1.50392C11.9762 1.22561 11.7506 1 11.4723 1C11.194 1 10.9683 1.22561 10.9683 1.50392V3.54545H8.49592C8.16814 3.54545 7.91795 3.83837 7.96919 4.16211C8.0102 4.42122 8.23358 4.61202 8.49591 4.61202H13.2949C13.6678 4.61202 13.9599 4.93292 13.925 5.30426L13.1608 13.4166C13.1302 13.7417 12.8572 13.9901 12.5307 13.9901H9.98049C9.70023 13.9901 9.47359 14.2184 9.47556 14.4986C9.47752 14.7761 9.70301 15 9.98049 15H13.1442C13.6521 15 14.0694 14.5864 14.1298 14.0645L14.9304 5.62337C15.0361 4.50896 14.1597 3.54545 13.0403 3.54545H11.9762Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97841 7.12491C1.8368 6.85774 1.9451 6.58051 2.16224 6.47974C3.0953 6.04672 4.57156 5.49636 6 5.49636C7.43539 5.49636 8.9189 6.05207 9.85085 6.48582C10.0657 6.58584 10.1743 6.85915 10.0378 7.12557L6.56124 13.9153C6.35758 14.313 5.79054 14.3171 5.58127 13.9222L1.97841 7.12491Z",
    stroke: "currentColor",
    strokeWidth: 1.10503,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84082 8.08897C3.89771 7.59943 4.95061 7.35466 5.99952 7.35466C7.04669 7.35466 8.09784 7.59862 9.15297 8.08654",
    stroke: "currentColor",
    strokeWidth: 1.10503,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.7787,
    cy: 10.1664,
    r: 0.555556,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.3329,
    cy: 9.49965,
    r: 0.555556,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.9994,
    cy: 11.4996,
    r: 0.555556,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodanddrinks);
export default __webpack_public_path__ + "static/media/food and drinks.35ce4111b56ed26d5afa94d7e6c917f5.svg";
export { ForwardRef as ReactComponent };